const Boolean = () => (
  <>
    <path
      fill="currentColor"
      d="M12 16V8q-1.672 0-2.835 1.165Q8 10.328 8 12t1.165 2.835Q10.328 16 12 16"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
  </>
)
export default Boolean
